import { Route } from '../domain/route/Route';
import { Stop } from '../domain/stop/Stop';
import { stopRepository } from '../repositories/stop';
import { StopRepository } from '../repositories/stop/StopRepository';

class StopService {
  constructor(private stopRepository: StopRepository) {}

  async validatePin({ stop, pin }: { stop: Stop; pin: string }): Promise<void> {
    return this.stopRepository.validatePin({ stop, pin });
  }

  async sendPin({ stop, method }: { stop: Stop; method: `email` | `sms` }): Promise<void> {
    return this.stopRepository.sendPin({ stop, method });
  }

  async updateStop({ stop, stopId }: { stop: Stop; stopId: string }): Promise<Stop> {
    return this.stopRepository.updateStop({ newStop: stop, stopId });
  }

  async deleteStop({ stop }: { stop: Stop }): Promise<Route> {
    return this.stopRepository.deleteStop({ stop });
  }
  async deleteStops({ stops }: { stops: string[] }): Promise<Route> {
    return this.stopRepository.deleteStops({ stops });
  }
  async copyStops({
    route_destination_id,
    route_origin_id,
    stops,
  }: {
    route_destination_id: string;
    route_origin_id: string;
    stops: string[];
  }): Promise<Route> {
    return this.stopRepository.copyStops({ route_destination_id, route_origin_id, stops });
  }
}

export const stopService = new StopService(stopRepository);
